export default __webpack_public_path__ + "static/media/phone-2.9cea9400.png";